import Vue from 'vue'
import FrostedGlass from './FrostedGlass.vue'
import Dialog from './Dialog.vue'
import Avatar from './Avatar/index.vue'
import Circle from './Circle/index.vue'
import SpecialityItem from './SpecialityItem/index.vue'
import CountrySelect from './CountrySelect/index.vue'
import ValidationField from './ValidationField'
import LanguageSelector from './LanguageSelector.vue'

export function register() {
  Vue.component('g-frosted-glass', FrostedGlass)
  Vue.component('g-dialog', Dialog)
  Vue.component('g-avatar', Avatar)
  Vue.component('g-circle', Circle)
  Vue.component('g-speciality-item', SpecialityItem)
  Vue.component('g-country-select', CountrySelect)
  Vue.component('g-validation-field', ValidationField)
  Vue.component('g-language-selector', LanguageSelector)
}
